{
  "familyId": "TOPO-EU-ZEEEN",
  "questions": [
    {
      "id": "TOPO-EU-ZEEEN-001",
      "familyId": "TOPO-EU-ZEEEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_zeeen_eu",
      "questionType": "multiple_choice",
      "question": "Welke zee ligt tussen Groot-Brittannië en Scandinavië?",
      "options": [
        "De Noordzee",
        "De Middellandse Zee",
        "De Oostzee",
        "De Zwarte Zee"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_zeeen_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zeeën rond Europa",
            "content": "Noordzee: tussen GB, Nederland, Duitsland en Scandinavië. Oostzee: tussen Scandinavië en Oost-Europa. Middellandse Zee: tussen Zuid-Europa en Noord-Afrika. Zwarte Zee: bij Turkije en Oekraïne.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "zeeen_noordzee",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "De Noordzee ligt tussen Groot-Brittannië aan de westkant en Scandinavië (Noorwegen, Denemarken) aan de oostkant. Nederland, België en Duitsland liggen aan de zuidkant.",
        "solutionSteps": [
          "Noordzee = tussen GB en Scandinavië",
          "Nederland ligt aan de zuidkust van de Noordzee",
          "Belangrijk voor scheepvaart en visserij"
        ],
        "distractorExplanations": {
          "0": "Goed! De Noordzee ligt tussen Groot-Brittannië en Scandinavië.",
          "1": "De Middellandse Zee ligt veel zuidelijker, tussen Zuid-Europa en Noord-Afrika.",
          "2": "De Oostzee ligt aan de andere kant van Scandinavië, tussen Zweden/Finland en de Baltische staten.",
          "3": "De Zwarte Zee ligt in het zuidoosten van Europa, bij Turkije en Oekraïne."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-ZEEEN-001-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Middellandse Zee"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-ZEEEN-001-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Oostzee"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-ZEEEN-001-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Zwarte Zee"
          }
        ]
      }
    },
    {
      "id": "TOPO-EU-ZEEEN-002",
      "familyId": "TOPO-EU-ZEEEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_zeeen_eu",
      "questionType": "multiple_choice",
      "question": "Welke zee is bijna helemaal omsloten door land en ligt tussen Europa, Azië en Afrika?",
      "options": [
        "De Middellandse Zee",
        "De Noordzee",
        "De Atlantische Oceaan",
        "De Oostzee"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_zeeen_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Middellandse Zee",
            "content": "De Middellandse Zee ligt tussen drie continenten: Europa (noord), Afrika (zuid) en Azië (oost). De enige verbinding met de oceaan is de Straat van Gibraltar.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "zeeen_middellandse",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De Middellandse Zee ligt tussen Europa, Afrika en Azië. Het is bijna helemaal omsloten door land — alleen bij de Straat van Gibraltar is er een smalle doorgang naar de Atlantische Oceaan.",
        "solutionSteps": [
          "Middellandse Zee = tussen 3 continenten",
          "Europa (noord), Afrika (zuid), Azië (oost)",
          "Bijna helemaal omsloten door land"
        ],
        "distractorExplanations": {
          "0": "Goed! De Middellandse Zee ligt tussen Europa, Afrika en Azië.",
          "1": "De Noordzee ligt alleen in Europa, niet bij Afrika of Azië.",
          "2": "De Atlantische Oceaan is een oceaan, geen zee. Hij is niet omsloten door land.",
          "3": "De Oostzee ligt alleen in Noord-Europa, niet bij Afrika of Azië."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-ZEEEN-002-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Noordzee"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-ZEEEN-002-OPT2",
            "optionIndex": 2,
            "label": "Hij is niet omsloten door land"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-ZEEEN-002-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Oostzee"
          }
        ]
      }
    },
    {
      "id": "TOPO-EU-ZEEEN-003",
      "familyId": "TOPO-EU-ZEEEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_zeeen_eu",
      "questionType": "multiple_choice",
      "question": "Welke zee ligt tussen Zweden, Finland en de Baltische staten (Estland, Letland, Litouwen)?",
      "options": [
        "De Oostzee",
        "De Noordzee",
        "De Zwarte Zee",
        "De Waddenzee"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_zeeen_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oostzee",
            "content": "De Oostzee (ook wel Baltische Zee) ligt in Noord-Europa. Landen eromheen: Zweden, Finland, Estland, Letland, Litouwen, Polen, Duitsland, Denemarken. Het water is minder zout dan de oceaan.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "zeeen_oostzee",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De Oostzee (ook wel Baltische Zee genoemd) ligt aan de oostkant van Scandinavië, tussen Zweden/Finland en de Baltische staten (Estland, Letland, Litouwen). Het is een binnenzee van Noord-Europa met relatief weinig zout water. Landen eromheen zijn ook Polen, Duitsland en Denemarken. Een veelvoorkomende verwisseling is de Noordzee en de Oostzee: de Noordzee ligt aan de wéstkant van Scandinavië, de Oostzee aan de óóstkant.",
        "solutionSteps": [
          "Oostzee = aan de oostkant van Scandinavië",
          "Ligt tussen Zweden/Finland en de Baltische staten",
          "Ook wel Baltische Zee genoemd",
          "Landen: Zweden, Finland, Estland, Letland, Litouwen, Polen, Duitsland, Denemarken"
        ],
        "distractorExplanations": {
          "0": "Goed! De Oostzee (Baltische Zee) ligt tussen Scandinavië en de Baltische staten.",
          "1": "De Noordzee en Oostzee worden vaak verwisseld. De Noordzee ligt aan de wéstkant van Scandinavië (bij Noorwegen en Denemarken), de Oostzee aan de óóstkant (bij Zweden en Finland).",
          "2": "De Zwarte Zee ligt in een heel ander deel van Europa — in het zuidoosten, bij Turkije en Oekraïne. De Oostzee ligt in het noorden van Europa.",
          "3": "De Waddenzee is een kleine, ondiepe zee bij de Nederlandse en Duitse Waddeneilanden. De Oostzee is veel groter en ligt in Noord-Europa."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-ZEEEN-003-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Noordzee"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-ZEEEN-003-OPT2",
            "optionIndex": 2,
            "label": "De Oostzee ligt in het noorden van Europa"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-ZEEEN-003-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Waddenzee"
          }
        ]
      }
    },
    {
      "id": "TOPO-EU-ZEEEN-004",
      "familyId": "TOPO-EU-ZEEEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_zeeen_eu",
      "questionType": "multiple_choice",
      "question": "Welke zee ligt bij Turkije, Roemenië, Bulgarije en Oekraïne?",
      "options": [
        "De Zwarte Zee",
        "De Rode Zee",
        "De Kaspische Zee",
        "De Middellandse Zee"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_zeeen_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zwarte Zee",
            "content": "De Zwarte Zee ligt in Zuidoost-Europa/West-Azië. Landen eromheen: Turkije (zuid), Bulgarije en Roemenië (west), Oekraïne (noord), Georgië (oost). Verbonden met de Middellandse Zee via de Bosporus.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "zeeen_zwarte",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De Zwarte Zee ligt in het zuidoosten van Europa. Turkije ligt aan de zuidkust, Roemenië en Bulgarije aan de westkust, en Oekraïne aan de noordkust. Via de Bosporus (de smalle zeestraat bij Istanbul) is de Zwarte Zee verbonden met de Middellandse Zee. Een veelvoorkomende verwisseling is de Zwarte Zee met de Rode Zee — de Rode Zee ligt tussen Afrika en het Arabisch Schiereiland, ver van Europa.",
        "solutionSteps": [
          "Zwarte Zee = zuidoost-Europa",
          "Landen: Turkije (zuid), Roemenië en Bulgarije (west), Oekraïne (noord), Georgië (oost)",
          "Verbonden met de Middellandse Zee via de Bosporus bij Istanbul",
          "Niet verwarren met de Rode Zee (die ligt bij Afrika)"
        ],
        "distractorExplanations": {
          "0": "Goed! De Zwarte Zee ligt bij Turkije, Roemenië, Bulgarije en Oekraïne in zuidoost-Europa.",
          "1": "De Rode Zee en Zwarte Zee worden soms verwisseld vanwege de kleur in de naam. De Rode Zee ligt tussen Afrika en het Arabisch Schiereiland — ver van Europa. De Zwarte Zee ligt in zuidoost-Europa.",
          "2": "De Kaspische Zee ligt verder naar het oosten, bij Rusland, Kazachstan en Iran. De Zwarte Zee ligt westelijker, bij Turkije en Oekraïne. Beide liggen in dezelfde regio maar zijn verschillende wateren.",
          "3": "De Middellandse Zee ligt westelijker in Europa, bij Spanje, Italië en Griekenland. De Zwarte Zee is via de Bosporus met de Middellandse Zee verbonden, maar het zijn twee aparte zeeën."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-ZEEEN-004-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Rode Zee"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-ZEEEN-004-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Kaspische Zee"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-ZEEEN-004-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Middellandse Zee"
          }
        ]
      }
    },
    {
      "id": "TOPO-EU-ZEEEN-005",
      "familyId": "TOPO-EU-ZEEEN",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_zeeen_eu",
      "questionType": "matching",
      "question": "Koppel elke zee aan de juiste ligging.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Noordzee",
            "right": "Tussen GB en Scandinavië"
          },
          {
            "left": "Middellandse Zee",
            "right": "Tussen Europa en Afrika"
          },
          {
            "left": "Oostzee",
            "right": "Tussen Scandinavië en Baltische staten"
          },
          {
            "left": "Zwarte Zee",
            "right": "Bij Turkije en Oekraïne"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_zeeen_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Europese zeeën",
            "content": "Noordzee: NW-Europa. Middellandse Zee: Zuid-Europa/N-Afrika. Oostzee: N-Europa. Zwarte Zee: ZO-Europa.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "zeeen_match",
      "variantIndex": 5,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Noordzee → NW-Europa. Middellandse Zee → tussen Europa en Afrika. Oostzee → Noord-Europa. Zwarte Zee → Zuidoost-Europa.",
        "solutionSteps": [
          "Noordzee → Tussen GB en Scandinavië",
          "Middellandse Zee → Tussen Europa en Afrika",
          "Oostzee → Tussen Scandinavië en Baltische staten",
          "Zwarte Zee → Bij Turkije en Oekraïne"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    }
  ]
}